import { IconEdit } from "@studyplus/boron-ui";
import * as React from "react";
import { Link } from "react-router-dom";
import { AiAssistantTemplateInterface } from "../../useFetchAiAssistantTemplates";
import styles from "./styles.scss";

interface Props {
  sectionId: string;
  aiAssistantTemplates: AiAssistantTemplateInterface[];
}

const AiAssistantTemplateList = (props: Props): React.ReactElement<any> => {
  return (
    <div className={styles.tableWrapper}>
      <table>
        <thead>
          <tr>
            <th>テンプレート名</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {props.aiAssistantTemplates.length === 0 ? (
            <tr>
              <td colSpan={2} className="text-center">
                登録がありません
              </td>
            </tr>
          ) : (
            props.aiAssistantTemplates.map(
              (template: AiAssistantTemplateInterface) => (
                <tr key={`ai_assistant_template-${template.id}`}>
                  <td>{template.name}</td>
                  <td>
                    <Link
                      to={`/sections/${props.sectionId}/settings/ai_assistant_templates/${template.id}/edit`}
                      className={styles.link}
                    >
                      <IconEdit className="h-[2.4rem] w-[2.4rem] fill-current" />
                      編集
                    </Link>
                  </td>
                </tr>
              ),
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AiAssistantTemplateList;
